// extracted by mini-css-extract-plugin
export default {"userBoxItem":"UserBoxItem_userBoxItem__AzIl7","userBoxLink":"UserBoxItem_userBoxLink__rtSZD"};